import { CAPSULE_AND_TABLET_FORM_CODES } from "../drug-codes/constants.js";

//#region src/utilities/get-package-relevance.ts
function getPackageRelevance(packageInfo) {
	const { formCode, packageCode, packageSizeUnit, packageQuantity } = packageInfo;
	const sizeUnit = packageSizeUnit ? packageSizeUnit.toLowerCase() : "";
	if (sizeUnit === "ea") {
		if (CAPSULE_AND_TABLET_FORM_CODES.has(formCode ?? "") && packageQuantity === 1 && packageCode !== "DP") return {
			isSimpleQuantity: true,
			isPackageRelevant: false
		};
		return {
			isSimpleQuantity: true,
			isPackageRelevant: true
		};
	} else if (sizeUnit === "ml" || sizeUnit === "gm") {
		if (packageQuantity && packageQuantity > 1) return {
			isSimpleQuantity: false,
			isPackageRelevant: true
		};
		return {
			isSimpleQuantity: false,
			isPackageRelevant: false
		};
	}
}

//#endregion
export { getPackageRelevance };